import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import FormGroup from './FormGroup'

const CheckboxBlock = ( props ) => {
  const myRef = useRef(null)
  const inputFreeze = useSelector((state) => state.calculation.input.inputFreeze)
  const { warning, name, value, id, options, label, inputLabel, popoverText, onChange, containerProps } = props

  const handleChange = (e) => {
    onChange(name, e.target.checked)
  }
  const handleBlur = () => {
    myRef.current.classList.remove('-focused')
  }
  const handleFocus = (e) => {
    myRef.current.classList.add('-focused')
  }

  const myValue = (typeof(value) === 'string') ? JSON.parse(value) : value

  return (
    <FormGroup ref={myRef} warning={warning} label={label} inputLabel={inputLabel} popoverText={popoverText}>
      <input type="checkbox" id={id ? id : name} name={name} checked={myValue} disabled={inputFreeze} onChange={handleChange} onBlur={handleBlur} onFocus={handleFocus} {...containerProps} />
      <label htmlFor={id ? id : name}>
        <span style={{display:"inline"}}>{inputLabel}</span>
      </label>
    </FormGroup>
  )
}
export default CheckboxBlock
